import React from 'react';
import './StatsCard.css';

export default function StatsCard({ title, value, icon, color, trend, trendValue }) {
  return (
    <div className="stats-card" style={{ borderTopColor: color }}>
      <div className="stats-card__header">
        <span className="stats-card__icon" style={{ backgroundColor: `${color}20`, color }}>
          {icon}
        </span>
        {trend && (
          <span className={`stats-card__trend stats-card__trend--${trend}`}>
            {trend === 'up' ? '↑' : '↓'} {trendValue}
          </span>
        )}
      </div>
      
      <div className="stats-card__body">
        <h3 className="stats-card__title">{title}</h3>
        <p className="stats-card__value">{value}</p>
      </div>
    </div>
  );
}
